import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastSubject = new BehaviorSubject<any>({
    appearance: 'success',
    open: false,
    message: ''
  })

  toast$ = this.toastSubject.asObservable()


  closeToast() {
    setTimeout(() => {
      this.toastSubject.next({ ...this.toastSubject, open: false })
    }, 5000)
  }

  success(message: string) {
    this.toastSubject.next({ open: true, message: message, appearance: 'success', icon: 'check-circle' })
    this.closeToast()
  }

  warning(message: string) {
    this.toastSubject.next({ open: true, message: message, appearance: 'warning', icon: 'exclamation-triangle' })
    this.closeToast()
  }

  error(message: string) {
    this.toastSubject.next({ open: true, message: message, appearance: 'error', icon: 'exclamation-octagon' })
    this.closeToast()
  }

  info(message: string) {
    this.toastSubject.next({ open: true, message: message, appearance: 'info', icon: 'info-circle' })
    this.closeToast()
  }

}
